var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5993,
    cy: 10.0007,
    r: 6.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 1.66602C15.2024 1.66602 18.9333 5.39685 18.9333 9.99935C18.9333 14.6018 15.2024 18.3327 10.5999 18.3327C5.99744 18.3327 2.2666 14.6018 2.2666 9.99935C2.2666 5.39685 5.99744 1.66602 10.5999 1.66602ZM10.5999 5.83268C10.4489 5.83269 10.303 5.88738 10.1892 5.98666C10.0753 6.08593 10.0013 6.22305 9.98077 6.37268L9.97494 6.45768V9.37435H7.05827C6.89992 9.3744 6.74748 9.43455 6.63178 9.54266C6.51607 9.65077 6.44571 9.79877 6.43491 9.95675C6.42412 10.1147 6.4737 10.2709 6.57363 10.3938C6.67356 10.5166 6.81639 10.5969 6.97327 10.6185L7.05827 10.6243H9.97494V13.541C9.97498 13.6994 10.0351 13.8518 10.1432 13.9675C10.2514 14.0832 10.3994 14.1536 10.5573 14.1644C10.7153 14.1752 10.8715 14.1256 10.9944 14.0257C11.1172 13.9257 11.1975 13.7829 11.2191 13.626L11.2249 13.541V10.6243H14.1416C14.3 10.6243 14.4524 10.5641 14.5681 10.456C14.6838 10.3479 14.7542 10.1999 14.765 10.0419C14.7758 9.88396 14.7262 9.72777 14.6262 9.60493C14.5263 9.48209 14.3835 9.40177 14.2266 9.38018L14.1416 9.37435H11.2249V6.45768C11.2249 6.29192 11.1591 6.13295 11.0419 6.01574C10.9247 5.89853 10.7657 5.83268 10.5999 5.83268Z",
    fill: "#6D1DF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilled);
export default __webpack_public_path__ + "static/media/add-filled.334895d4686aae72787e1eeeeb689f13.svg";
export { ForwardRef as ReactComponent };